import { RadioButtonWithLabelGroupWidget, RadioButtonWithLabelOption } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { PublishedConnectionExtractRefreshLevel } from '~src/publishedConnection/types/PublishedConnectionExtractRefreshLevel';
import { cssClass } from '~src/style';

const cssPrefix = 'PublishedConnectionExtractRefreshLevelOptions';
const paddingBottomClass = cssClass(cssPrefix, 'paddingBottom', {
  paddingBottom: CommonStyles.Sizes.LargeSpace,
});

function createRadioButtonOptions(): RadioButtonWithLabelOption<PublishedConnectionExtractRefreshLevel>[] {
  return [
    {
      value: PublishedConnectionExtractRefreshLevel.Database,
      testId: 'published-connection-refresh-level-database',
      label: Messages.publishedConnectionTableSyncRefreshMessage()
    },
    {
      value: PublishedConnectionExtractRefreshLevel.Table,
      testId: 'published-connection-refresh-level-table',
      label: Messages.publishedConnectionTableIndependentRefreshMessage()
    }
  ];
}

export type PublishedConnectionExtractRefreshLevelOptionsProps = Readonly<{
  selected: PublishedConnectionExtractRefreshLevel;
  onChange: (level: PublishedConnectionExtractRefreshLevel) => void;
}>;

export function PublishedConnectionExtractRefreshLevelOptions(props: PublishedConnectionExtractRefreshLevelOptionsProps): JSX.Element {

  return (
    <RadioButtonWithLabelGroupWidget
      aria-label={Messages.publishedConnectionRefreshLevelRadioGroupLabel()}
      buttonList={createRadioButtonOptions()}
      className={paddingBottomClass}
      checkedIndex={props.selected === PublishedConnectionExtractRefreshLevel.Database ? 0 : 1}
      handleChange={props.onChange}
    />
  );
}
